/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import { supportTypes } from '..';

import { CloseButton } from '../../CloseButton';

export const SupportTypeStep = ({ onSupportTypeChanged }) => (
  <>
    <header style={{
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between',
    }}>
      <span style={{
        color: '#898887',
        textAlign: 'left',
        paddingLeft: 0
      }}
      >
       Escolha a categoria do suporte
      </span>

      <CloseButton />
    </header>

    <div
      style={{
        width: '100%',
        display: 'flex',
        padding: '32px 0',
        gap: '8px',
      }}
    >
      {Object.entries(supportTypes).map(([key, value]) => (
        <button
          key={key}
          type="button"
          style={{
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '8px',
            border: '2px solid transparent',
            backgroundColor: '#E5E7EB',
            borderRadius: '0.5rem',
            padding: '20px 0',
            cursor: 'pointer',
          }}
          onClick={() => onSupportTypeChanged(key)}
        >
          <img src={value.image.source} alt={value.image.alt}  style={{
            maxWidth: '40px',
          }}/>
          <span
            style={{
              color: '#898887',
              textAlign: 'center',
              fontSize: '14px',
              lineHeight: '20px',
              fontWeight: 'bold',
              padding: 0
            }}
          >
            {value.title}
          </span>
        </button>
      ))}
    </div>
  </>
);
